export default __webpack_public_path__ + "static/media/molistourBack.4f881619.png";